import React, { Component } from 'react'
import convertFlatSchemaToState from '@rwitl/reformed-util/lib/convertFlatSchemaToState'
import Product from '@rwitl/screen-renderer/lib/Product'
import PropTypes from 'prop-types'
import mergeStateToFlatSchema from '@rwitl/reformed-util/lib/mergeStateToFlatSchema'
import ScreenRenderer from './ScreenRenderer'
import editorReducer from './editorReducer'
import pruneScreenState from './pruneScreenState'

// This is just work in progress mind mapping product structure
class ProductEditor extends Component {

  constructor(props){
    super(props)
    this.screenState_ = createScreenState(props.flatSchema)
  }

  static propTypes = {
    branchId: PropTypes.string,
  }

  componentWillReceiveProps = (newProps) => {
    // Unless the branchId changes don't bother updating the screenState
    // as this should always be current anyway
    if (newProps.branchId != this.props.branchId)
      this.screenState_ = createScreenState(newProps.flatSchema)
  }

  onScreenStateChange = (screenState) => {
    this.screenState_ = screenState
    // This is needed else `onControlUpdates` won't trigger updates
    this.forceUpdate()
    var { flatSchema, onFlatSchemaChange } = this.props
    flatSchema = JSON.parse(JSON.stringify(flatSchema))
    flatSchema = mergeStateToFlatSchema(flatSchema, pruneScreenState(screenState))
    //flatSchema = mergeStateToFlatSchema(flatSchema, screenState)
    onFlatSchemaChange(flatSchema)
  };

  render = () => {

    const { flatSchema } = this.props

    return <div>

      <Product
        screenState={this.screenState_}
        getScreenState={() => this.screenState_}
        flatSchema={flatSchema}
        relativeUrl=""
        onRelativeUrlChange={noop}
        onScreenStateChange={this.onScreenStateChange} // TODO
        reducer={editorReducer} // TODO
      >
        <ScreenRenderer />
      </Product>
    </div>
  }
}

export default ProductEditor

function noop(){}

function createScreenState(flatSchema){
  // TODO Should probably add one child screen in all places so we
  // can edit child screens too
  return convertFlatSchemaToState(flatSchema)
}


// WEBPACK FOOTER //
// ./src/modules/BranchEditor/ProductEditor/ProductEditor.js